import React, { useEffect, useState } from 'react';
import { CSSTransition } from 'react-transition-group';
import { useExpandableWrapper } from '../../hooks';
import { Wrapper } from './expandable-wrapper.styled';

interface Props {
  children: React.ReactChild;
  isExpanded: boolean;
  ms?: number;
}

/* Children обязательно должен либо иметь единую обертку, либо обернут в React.Fragment.
 * Также потомки или родитель (в зависимости от конкретной ситуации) обязательно должны иметь overflow-y: hidden для корректной анимации */
export const ExpandableWrapper = ({
  children,
  isExpanded,
  ms = 200,
}: Props) => {
  const { onEnterOrExit, onEntered, onExiting, state } = useExpandableWrapper();
  const [isOpen, setIsOpen] = useState<boolean>(isExpanded);
  const [isCollapsed, setIsCollapsed] = useState<boolean>(!isExpanded);
  const [isFirstRender, setIsFirstRender] = useState<boolean>(true);
  let timeout: NodeJS.Timeout;

  useEffect(() => {
    return () => clearTimeout(timeout);
  }, []);

  useEffect(() => {
    if (!isFirstRender) {
      toggle();
    } else {
      setIsFirstRender(false);
    }
  }, [isExpanded]);

  const toggle = (): void => {
    if (isOpen) {
      setIsCollapsed((prevState) => !prevState);
      timeout = setTimeout(() => setIsOpen((prevState) => !prevState), ms);
    } else {
      setIsOpen((prevState) => !prevState);
      timeout = setTimeout(() => setIsCollapsed((prevState) => !prevState), 1);
    }
  };

  return (
    <>
      {isOpen && !isFirstRender && (
        <Wrapper ms={ms} style={{ height: state.childHeight }}>
          <CSSTransition
            in={!isCollapsed}
            timeout={ms}
            classNames={'expandableWrapper'}
            onEnter={onEnterOrExit}
            onEntered={onEntered}
            onExit={onEnterOrExit}
            onExiting={onExiting}
            unmountOnExit
            nodeRef={state.ref}
          >
            <div ref={state.ref}>{children}</div>
          </CSSTransition>
        </Wrapper>
      )}
    </>
  );
};
